import {useContext} from 'react';

import {SearchFormContext} from '../contexts/SearchFormContext';

function useSearchFormContext() {
    return useContext(SearchFormContext);
}

export {useSearchFormContext};
